import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import ModelCity from './pages/modelCity';
import ModelLevers from './pages/modelLevers';
import ModelResults from './pages/modelResults';

export default () => (
  <BrowserRouter>
    <Switch>
      <Route exact path='/' component={ModelCity} />
      <Route exact path='/levers' component={ModelLevers} />
      <Route exact path='/results' component={ModelResults} />
      <Redirect to='/levers' />
      {/* <Route path='/404' component={NotFound} />
      <Redirect to='/login' /> */}
    </Switch>
  </BrowserRouter>
);



// WEBPACK FOOTER //
// ./src/routes.js